export default {"src":"/_next/static/media/global.927a7020.svg","height":50,"width":70};